import {
    Divider,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
  } from "@chakra-ui/react";
  import React, { useMemo, useState } from "react";
  import { useDispatch } from "react-redux";

  import {Form,Col,Row} from "react-bootstrap";
  import moment from "moment";
  import { poNumberFormate } from "jsFunctions/helperFunctions";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { fetchAsyncResourcePONum } from "redux/tdsSlice";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import PaymentInfo from "./components/paymentInfo";
import InvoiceInfo from "./components/invoicceInfo";
import RefundInfo from "./components/refundInfo";
  
  const DataRow = ({ label, value, type }) => {
    return (
      <>
          <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">₹</span> </InputGroup.Text>
        <Form.Control
         type="text"
         value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const TdsInfoModel = ({ openInfoModal, closeInfoModal, selectedItem, role }) => {
    const dispatch = useDispatch();
  
    const [activeTab, setActiveTab] = useState("information");
    const [historyTab, setHistoryTab] = useState("requested");
    const [poNoResource, setPoNoResource] = useState({})

    const getPoMonth = useMemo(() => {
      if (selectedItem.oM) {
        const date = moment(selectedItem.oM);
        const month = date.format("MMM");
        const year = date.format("YYYY");
        return `${year}-${month}`;
      }
      return "";
    }, [selectedItem.oM]);

    const fetchResourcePONum = async () => {
      if (selectedItem?.rfPo) {
        const res = await dispatch(fetchAsyncResourcePONum());
        if (res.payload) {
          const resourcePoNo = res.payload.map(item => ({
            _id: item._id,
            poNo: poNumberFormate(item.poNo),
          }));
  
          const filteredArray = resourcePoNo.filter(item => item._id === selectedItem.rfPo);
          const obj = filteredArray.length > 0 ? filteredArray[0] : null;
          setPoNoResource(obj);
        }
      }
    };
  
    if (selectedItem?.rfPo) {
      fetchResourcePONum();
    }
   
    const remainingAmount = useMemo(() => {
      const totalPayAmount = parseFloat(selectedItem?.pyInfo?.tlAmt || 0) - parseFloat(selectedItem?.tdsApl?.tlAmt || 0);
      const list = selectedItem?.pyInfo?.list || [];
  
      if (list.length > 0) {
        const sum = list.reduce((acc, current) => {
          const amount = parseFloat(current?.amt || 0);
          return acc + (isNaN(amount) ? 0 : amount);
        }, 0);
        return totalPayAmount - sum;
      }
  
      return totalPayAmount;
    }, [selectedItem]);
   
  
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent  
          top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>TDS - Expense</span>
              </ModalHeader>
              <ModalCloseButton  />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5"> Purchase Order Details</h5>
  
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Order Number"
                            value={poNumberFormate(selectedItem.poNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Order Month" value={getPoMonth} />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Order Date"
                            value={
                              selectedItem.oDt
                                ? moment(selectedItem.oDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Resource Name"
                            value={(selectedItem?.resId && selectedItem?.resId?.name) ? selectedItem?.resId?.name : ""}
                          />
                        </Col>
                      </Row>
  
                     
                     <Row className="info-row">
                    
                        <Col>
                          <DataRow
                            label="PAN Number"
                            value={selectedItem?.pnNo}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Reference Resource PO"
                            value={poNoResource?.poNo}
                          />
                        </Col>
                     </Row>
                     <Row className="info-row mb-3">
                        <Col>
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            disabled
                            rows={4}
                            value={selectedItem?.rmks}
                          />
                        </Col>
                      </Row>
                     
                     <Divider
                      className="info-divider"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">TDS Applicable</h5>
                    

                   
                      <>
                        <Row className="info-row">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                type="Amount"
                                label="Total Amount "
                                value={selectedItem?.tlBlAmt}
                              />
                            </Flex>
                          </Col>
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="TDS Percent "
                                value={selectedItem?.prc}
                              />
                            </Flex>
                          </Col>
                        </Row>
                        <Row className="info-row mb-3">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                              type="Amount"
                                label="TDS Amount  "
                                value={selectedItem?.tdsAmt}
                              />
                            </Flex>
                          </Col>
                         <Col></Col>
                        </Row>
                      </>
                  
                    
                     
  
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Payment Information</h5>
                      <PaymentInfo selectedItem = {selectedItem} remainingAmount={remainingAmount} expenseType="tds"/>
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Refund Amount Information</h5>
                      <RefundInfo selectedItem = {selectedItem}/>
                     
  
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Invoice</h5>
                      <InvoiceInfo selectedItem={selectedItem} />
                      
                    </div>
                  </Tab>
                  {role === "Manager" || role === "Admin" ? (
                    <Tab eventKey="history" title="History">
                      <Form className="addForm addform2">
                        <Tabs
                          id="justify-tab-example3"
                          activeKey={historyTab}
                          onSelect={(k) => setHistoryTab(k)}
                          transition={true}
                          className="mt-0"
                        >
                          <Tab
                            eventKey="requested"
                            className="inner-tab"
                            title="Requested"
                          >
                            <div className="inner-card">
                              <h5 className="heading-h5">Requested Amount Details</h5>
                              <Row className="info-row">
                                <Col className="check-cross-mark mt-2">
                                  <Form.Label>
                                    <span
                                      className={
                                        selectedItem.pyInfo.sts !==0 
                                          ? "checkmark"
                                          : "crossmark"
                                      }
                                    ></span>{" "}
                                    Is requested amount send for approval?
                                  </Form.Label>
                                  <br />
                                </Col>
                              </Row>
                              <Row className="info-row">
                                <Col>
                                  <DataRow
                                    label="Requested At"
                                    value={
                                      selectedItem.pyInfo?.rqAt
                                        ? moment(
                                          selectedItem.pyInfo?.rqAt
                                        ).format("DD-MMM-yyyy hh:mm A")
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Requested By"
                                    value={selectedItem.pyInfo?.rqBy?.name}
                                  />
                                </Col>
                              </Row>
  
                              <Divider
                                className="info-divider mt-3"
                                orientation="horizontal"
                              />
                              <h5 className="heading-h5">Last Updated Details</h5>
  
                              <Row className="info-row mb-3">
                                <Col>
                                  <DataRow
                                    label="Last Updated At"
                                    value={
                                      selectedItem.upAt
                                        ? moment(
                                            selectedItem.upAt
                                          ).format("DD-MMM-yyyy hh:mm A")
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Last Updated By"
                                    value={selectedItem?.upBy?.name}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Tab>
  
                          {!selectedItem.pyInfo?.sts !== 2
                      ?
                      <Tab eventKey="approved" title="Approved">
                      <div className="inner-card">
                        <h5 className="heading-h5">Requested Amount Details</h5>
                        <Row className="info-row">
                          <Col className="check-cross-mark mt-2">
                            <Form.Label>
                              <span
                                className={
                                  selectedItem.pyInfo?.sts === 1
                                    ? "checkmark"
                                    : "crossmark"
                                }
                              ></span>{" "}
                              Is requested amount is approved ?
                            </Form.Label>
                            <br />
                          </Col>
                        </Row>
                        <Row className="info-row">
                          <Col>
                            <DataRow
                              label="Approved At"
                              value={
                                selectedItem.pyInfo?.acnAt
                                  ? moment(
                                      selectedItem.pyInfo?.acnAt
                                    ).format("DD-MMM-yyyy hh:mm A")
                                  : ""
                              }
                            />
                          </Col>
                          <Col>
                            <DataRow
                              label="Approved By"
                              value={selectedItem.pyInfo?.acnBy?.name}
                            />
                          </Col>
                        </Row>

                        <Divider
                          className="info-divider mt-3"
                          orientation="horizontal"
                        />
                        <h5 className="heading-h5">Last Updated Details</h5>

                        <Row className="info-row mb-3">
                          <Col>
                            <DataRow
                              label="Last Updated At"
                              value={
                                selectedItem.upAt
                                  ? moment(
                                      selectedItem.upAt
                                    ).format("DD-MMM-yyyy hh:mm A")
                                  : ""
                              }
                            />
                          </Col>
                          <Col>
                            <DataRow
                              label="Last Updated By"
                              value={selectedItem?.upBy?.name}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                    :
                    <Tab eventKey="approved" title="Rejected">
                    <div className="inner-card">
                      <h5 className="heading-h5">Requested Amount Details</h5>
                      <Row className="info-row">
                        <Col className="check-cross-mark mt-2">
                          <Form.Label>
                            <span
                              className={
                                selectedItem.pyInfo
                                ?.sts === 2
                                  ? "checkmark"
                                  : "crossmark"
                              }
                            ></span>{" "}
                            Is requested amount is rejected ?
                          </Form.Label>
                          <br />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Rejected At"
                            value={
                              selectedItem.pyInfo?.acnAt
                                ? moment(
                                  selectedItem.pyInfo?.acnAt
                                ).format("DD-MMM-yyyy hh:mm A")
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Rejected By"
                            value={selectedItem.pyInfo?.acnBy?.name}
                          />
                        </Col>
                      </Row>

                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Last Updated Details</h5>

                      <Row className="info-row mb-3">
                        <Col>
                          <DataRow
                            label="Last Updated At"
                            value={
                              selectedItem.upAt
                                ? moment(
                                    selectedItem.upAt
                                  ).format("DD-MMM-yyyy hh:mm A")
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Last Updated By"
                            value={selectedItem?.upBy?.name}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Tab>
                      }
                        </Tabs>
                      </Form>
                    </Tab>
                  ) : (
                    <Tab eventKey="" title="" disabled></Tab>
                  )}
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default TdsInfoModel;
  